module.exports = __webpack_public_path__ + "static/img/i2.210e7a8b.png";